import { AfterViewChecked, Directive, ElementRef, inject, input, Renderer2 } from '@angular/core'
import { marked, Renderer } from 'marked'

@Directive({
  standalone: true,
  selector: '[markdown]',
})
export class MarkdownDirective implements AfterViewChecked {
  private readonly elementRef = inject(ElementRef)
  private readonly renderer = inject(Renderer2)

  /**
   * Whether the markdown renderer should convert "\n" into `<br>`. Otherwise, "\n" is just
   * converted into a space within the same paragraph.
   */
  readonly renderAllBreaks = input<boolean>(false)

  linkRenderer(): Renderer {
    const renderer = new Renderer()
    renderer.link = function (...args) {
      const link = Renderer.prototype.link.apply(this, args)
      return link.replace('<a', "<a target='_blank'")
    }
    return renderer
  }

  ngAfterViewChecked(): void {
    if (this.elementRef.nativeElement.innerText) {
      const markText = this.elementRef.nativeElement.innerHTML

      if (!markText || markText.length <= 0) {
        return
      }

      const customMarked = marked.setOptions({ renderer: this.linkRenderer(), breaks: this.renderAllBreaks() })

      const markdownHtml = customMarked(markText)

      if (this.elementRef.nativeElement.innerHTML === markdownHtml) {
        return
      }

      this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', markdownHtml)
    }
  }
}
